import { Box, IconButton, Typography, useTheme } from "@mui/material";
import React from "react";
// import NextIcon from "../../assets/icons/NextIcon";
// import PrevIcon from "../../assets/icons/PrevIcon";
import ChevronRightRoundedIcon from "@mui/icons-material/ChevronRightRounded";
import KeyboardArrowLeftRoundedIcon from "@mui/icons-material/KeyboardArrowLeftRounded";
import { tokens } from "../../theme";

interface IPagination {
  /** @deprecated use `page` instead — TODO: remove after migrating all call sites */
  currentPage?: number;
  totalPage: number;
  totalItems: number;
  setPage: React.Dispatch<React.SetStateAction<number>>;
  page: number;
  perPage?: number;
}

const Pagination = ({
  totalPage,
  totalItems,
  setPage,
  page,
  perPage = 10,
}: IPagination) => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);

  const getPaginationButtons = () => {
    let startPage = Math.max(page - 2, 1);
    let endPage = Math.min(startPage + 5, totalPage);

    if (endPage === totalPage) {
      startPage = Math.max(endPage - 5, 1);
    }

    const buttons = [];
    for (let i = startPage; i <= endPage; i++) {
      buttons.push(
        <IconButton key={i} onClick={() => setPage(i)}>
          <Box
            borderRadius={"100px"}
            textAlign={"center"}
            bgcolor={
              i === page ? colors.primary.activeText : colors.primary.bg
            }
            color={i === page ? colors.primary.bgChart : colors.primary.grayText}
            fontWeight={"300"}
            display="flex"
            alignItems="center"
            justifyContent={"center"}
            sx={{
              boxShadow: i === page ? "0px 0px 11.5px rgba(239,248,16,0.18)" : "none",
              fontSize: {
                xs: "11px",
                md: "16px",
              },
              height: {
                xs: "23px",
                md: "27px",
              },
              width: {
                xs: "23px",
                md: "27px",
              },
            }}
          >
            {i}
          </Box>
        </IconButton>,
      );
    }
    return buttons;
  };

  return (
    <Box
      display={"flex"}
      alignItems={"center"}
      justifyContent={"space-between"}
      width="100%"
      sx={{
        flexDirection: {
          xs: "column",
          md: "row",
        },
      }}
    >
      <Typography
        sx={{
          color: colors.primary.text,
          fontWeight: 300,
          fontSize: {
            xs: "9px",
            md: "16px",
          },
        }}
      >
        Showing {totalItems === 0 ? 0 : (page - 1) * perPage + 1} to{" "}
        {Math.min(page * perPage, totalItems)} of{" "}
        {totalItems} entries
      </Typography>

      <Box
        display={"flex"}
        alignItems={"center"}
        justifyContent={"center"}
        sx={{
          gap: {
            xs: "0px",
            md: "29px",
          },
        }}
      >
        <IconButton
          onClick={() => setPage((old) => Math.max(old - 1, 1))}
          disabled={page === 1}
          color={page === 1 ? "default" : "primary"}
          size="small"
        >
          <KeyboardArrowLeftRoundedIcon fontSize="large" />
        </IconButton>
        <Box display={"flex"} alignItems={"center"} justifyContent={"flex-end"}>
          {getPaginationButtons()}
          {totalPage > 6 && totalPage - 6 > page && (
            <Box
              borderRadius={"100px"}
              textAlign={"center"}
              bgcolor={colors.primary.bg}
              color={"#C7C7C7"}
              fontWeight={"300"}
              sx={{
                fontSize: {
                  xs: "11px",
                  md: "16px",
                },
                height: {
                  xs: "23px",
                  md: "27px",
                },
                width: {
                  xs: "23px",
                  md: "27px",
                },
                lineHeight: {
                  xs: "23px",
                  md: "27px",
                },
              }}
            >
              ...
            </Box>
          )}
        </Box>
        <IconButton
          onClick={() => setPage((old) => old + 1)}
          disabled={page === totalPage || totalPage <= 1}
          color={page === totalPage ? "default" : "primary"}
          size="small"
        >
          <ChevronRightRoundedIcon fontSize="large" />
        </IconButton>
      </Box>
    </Box>
  );
};

export default Pagination;
